import { intervalToDuration, formatDuration } from "date-fns";

export const formatMilliSeconds = (milliseconds?: number | null): string => {
  if (!milliseconds || milliseconds === 0) {
    return "0 seconds";
  }

  const duration = intervalToDuration({ start: 0, end: milliseconds });

  if (duration.minutes === 0 && duration.hours === 0) {
    return formatDuration(duration, { format: ["seconds"] });
  }

  if (duration.hours === 0) {
    return formatDuration(duration, { format: ["minutes", "seconds"] });
  }

  return formatDuration(duration, { format: ["hours", "minutes", "seconds"] });
};
